export const kpiData = [
  {name: 'ResponsivenessSeller', translationKey: 'buyer.invoiceDetails.kpis.responsivenessSeller', walkme: 'bdetails-image-vitessedacceptation'},
  {name: 'ResponsivenessDebtor', translationKey: 'buyer.invoiceDetails.kpis.responsivenessDebtor', walkme: 'bdetails-image-vitessedepaiement'}
];
